import React from 'react';

import Layout from '../components/Layout';
import thunai1 from '../assets/thunai1.png';
import thunai2 from '../assets/thunai2.png';
import cont1 from '../assets/cont1.png';
import cont21 from '../assets/cont21.png';
import cont22 from '../assets/cont22.png';
import entrans from '../assets/entrans.png';
import InteractiveTab from '../components/InteractiveTab';

const WorksPage = () => (
  <Layout>
    <section className="w-full min-h-screen flex flex-col items-center justify-start bg-black pt-16 px-4 sm:px-8 lg:px-16 xl:px-24">
      <div className="w-full max-w-screen-xl mx-auto flex flex-col lg:flex-row items-start justify-center gap-8 lg:gap-12">
        {/* Left: Main Heading */}
        <div className="flex flex-col items-start w-full lg:w-auto lg:flex-shrink-0">
          <h1
            className="text-white font-[500] mb-0 leading-[1.05] w-full"
            style={{
              fontFamily: 'Bricolage Grotesque, system-ui, sans-serif',
              fontWeight: 500,
              fontSize: 'clamp(3rem, 8vw, 7rem)',
              lineHeight: 'clamp(3rem, 7.5vw, 7rem)',
              letterSpacing: '-0.02em',
              maxWidth: '100%',
              wordBreak: 'break-word',
              textAlign: 'left',
            }}
          >
            Great Work<br/>That Works
          </h1>
        </div>
        {/* Right: Paragraphs - Positioned to align with heading lines */}
        <div className="flex flex-col justify-start w-full lg:w-auto lg:flex-1 lg:max-w-md lg:ml-4">
          {/* First paragraph aligns with "Great Work" */}
          <div className="mb-3 lg:mb-4">
            <p
              className="text-gray-300"
              style={{
                fontFamily: 'Space Grotesk, system-ui, sans-serif',
                fontWeight: 400,
                fontSize: 'clamp(1rem, 2vw, 1.25rem)',
                lineHeight: 'clamp(1.5rem, 2.5vw, 1.8rem)',
                letterSpacing: '-0.01em',
                textAlign: 'left',
                marginTop: 'clamp(0rem, 1vw, 0.5rem)',
              }}
            >
              Thoughtful design and messaging crafted to sharpen your value proposition, strengthen your brand, and tell your story with clarity.
            </p>
          </div>
          {/* Second paragraph aligns with "That Works" */}
          <div>
            <p
              className="text-gray-300"
              style={{
                fontFamily: 'Space Grotesk, system-ui, sans-serif',
                fontWeight: 400,
                fontSize: 'clamp(1rem, 2vw, 1.25rem)',
                lineHeight: 'clamp(1.5rem, 2.5vw, 1.8rem)',
                letterSpacing: '-0.01em',
                textAlign: 'left',
                marginTop: 'clamp(0.5rem, 2vw, 1rem)',
              }}
            >
              Built with a customer-first mindset to earn trust, drive action, and deliver real, measurable business results
            </p>
          </div>
        </div>
      </div>
      {/* Thunai Section */}
      <div className="w-full max-w-screen-xl mx-auto flex flex-col lg:flex-row items-start justify-between mt-24 gap-8 lg:gap-16">
        <div className="flex flex-col items-start w-full">
          <h2
            className="text-white mb-4"
            style={{
              fontFamily: 'Bricolage Grotesque, system-ui, sans-serif',
              fontWeight: 500,
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              lineHeight: 'clamp(2.5rem, 5vw, 4rem)',
              letterSpacing: '-0.02em',
            }}
          >
            Thunai
          </h2>
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between w-full gap-4 lg:gap-8">
            <p
              className="text-gray-300 flex-1"
              style={{
                fontFamily: 'Space Grotesk, system-ui, sans-serif',
                fontWeight: 400,
                fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
                lineHeight: 'clamp(1.6rem, 3vw, 2rem)',
                letterSpacing: '-0.01em',
                maxWidth: 'none',
              }}
            >
              Supercharge Enterprise Efficiency with AI Agents
            </p>
            {/* Badges */}
            <div className="flex flex-row gap-3 flex-shrink-0">
              <span
                style={{
                  background: 'rgba(234, 247, 39, 1)',
                  borderRadius: 25,
                  fontFamily: 'Bricolage Grotesque, system-ui, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)',
                  lineHeight: '1',
                  letterSpacing: '-0.01em',
                  padding: '0.7rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                  color: '#18181B',
                }}
              >
                Brand Identity
              </span>
              <span
                style={{
                  background: 'rgba(234, 247, 39, 1)',
                  borderRadius: 25,
                  fontFamily: 'Bricolage Grotesque, system-ui, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)',
                  lineHeight: '1',
                  letterSpacing: '-0.01em',
                  padding: '0.7rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                  color: '#18181B',
                }}
              >
                Website Revamp
              </span>
            </div>
          </div>
        </div>
      </div>
      <img src={thunai1} alt="Thunai" className="mx-auto w-full mt-12" style={{maxWidth: 1440, height: 'auto', display: 'block'}} />
      {/* White container for thunai2 and blue boxes */}
      <div className="mx-auto w-full mt-12 mb-12 flex flex-col items-center" style={{maxWidth: 1441, minHeight: 300, background: '#fff', borderRadius: 20, padding: '2rem'}}>
        <img src={thunai2} alt="Thunai" className="w-full h-auto mb-8" style={{maxWidth: 1385, borderRadius: 20, display: 'block'}} />
        <div className="w-full flex flex-col md:flex-row gap-6 justify-center items-stretch pb-0">
          <div className="flex-1 min-w-[260px] max-w-[664px] h-auto rounded-[20px] flex items-center justify-center overflow-hidden" style={{background: 'rgba(0, 34, 252, 1)', borderRadius: 20, minHeight: 200}}>
            <img src={cont1} alt="Content 1" style={{maxWidth: 590, height: 'auto', display: 'block'}} />
          </div>
          <div className="flex-1 min-w-[260px] max-w-[674px] h-auto rounded-[20px] flex items-center justify-center relative overflow-hidden" style={{background: 'rgba(0, 34, 252, 1)', borderRadius: 20, minHeight: 200}}>
            <img src={cont21} alt="Content 21" style={{maxWidth: 441, height: 'auto', display: 'block', position: 'relative', zIndex: 1}} />
            <img src={cont22} alt="Content 22" style={{maxWidth: 368, height: 'auto', display: 'block', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-30%, -10%)', zIndex: 2}} />
          </div>
        </div>
         {/* See Thunai Button */}
      <div className="w-full flex justify-center mt-10 mb-16">
        <button
          style={{
            width: 369,
            height: 110,
            borderRadius: 10,
            padding: '18px 34px',
            background: 'rgba(0, 0, 0, 1)',
            color: 'rgba(255, 255, 255, 1)',
            fontFamily: 'Space Grotesk',
            fontWeight: 700,
            fontSize: 32,
            lineHeight: '100%',
            letterSpacing: 0,
            textTransform: 'capitalize',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
          }}
        >
          See Thunai
        </button>
      </div>
      </div>
     
      {/* Entrans Section */}
      <div className="w-full max-w-screen-xl mx-auto flex flex-col lg:flex-row items-start justify-between mt-24 gap-8 lg:gap-16">
        <div className="flex flex-col items-start w-full">
          <h2
            className="text-white mb-4"
            style={{
              fontFamily: 'Bricolage Grotesque, system-ui, sans-serif',
              fontWeight: 500,
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              lineHeight: 'clamp(2.5rem, 5vw, 4rem)',
              letterSpacing: '-0.02em',
            }}
          >
            Entrans
          </h2>
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between w-full gap-4 lg:gap-8">
            <p
              className="text-gray-300 flex-1"
              style={{
                fontFamily: 'Space Grotesk, system-ui, sans-serif',
                fontWeight: 400,
                fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
                lineHeight: 'clamp(1.6rem, 3vw, 2rem)',
                letterSpacing: '-0.01em',
                maxWidth: 'none',
              }}
            >
              Engineering Consulting To Assist Global Enterprises
            </p>
            {/* Badges */}
            <div className="flex flex-row gap-3 flex-shrink-0">
              <span
                style={{
                  background: 'rgba(234, 247, 39, 1)',
                  borderRadius: 25,
                  fontFamily: 'Bricolage Grotesque, system-ui, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)',
                  lineHeight: '1',
                  letterSpacing: '-0.01em',
                  padding: '0.7rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                  color: '#18181B',
                }}
              >
                Brand Guidelines
              </span>
              <span
                style={{
                  background: 'rgba(234, 247, 39, 1)',
                  borderRadius: 25,
                  fontFamily: 'Bricolage Grotesque, system-ui, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)',
                  lineHeight: '1',
                  letterSpacing: '-0.01em',
                  padding: '0.7rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                  color: '#18181B',
                }}
              >
                Website Revamp
              </span>
            </div>
          </div>
        </div>
      </div>
      <img src={entrans} alt="Entrans" className="mx-auto w-full mt-12" style={{maxWidth: 1440, height: 'auto', display: 'block'}} />
    </section>
    <section className="w-full bg-black flex flex-col items-center py-16 px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 ">
      <h2
        className="text-white text-left w-full"
        style={{
          fontFamily: 'Bricolage Grotesque',
          fontWeight: 500,
          fontSize: '48px',
          marginBottom: 40,
          lineHeight: '60px',
          letterSpacing: '-1%',
          maxWidth: 1143,
        }}
      >
        Ready to turn your website or<br/>GTM assets into a growth engine?
      </h2>
      <div className="w-full max-w-screen-xl mx-auto">
        <InteractiveTab />
      </div>
    </section>
  </Layout>
);

export default WorksPage;